// import { jsPDF } from "jspdf";
// import banner1 from "../../../Assets/ptags/banner.jpg";
// import { Url, getAdjustedPrice } from "../../../Services/Api";

// import "../../../Assets/ptags/fonts/Montserrat-Bold";
// import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
// import "../../../Assets/ptags/fonts/Montserrat-Black";
// import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
// import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
// import "../../../Assets/ptags/fonts/anton";

// export const generatePDFOpt2 = (sectionsCount, bannerImg) => {
//     const width = 816;
//     const height = 1056;
//     const doc = new jsPDF({
//         orientation: "portrait",
//         unit: "pt",
//         format: [width, height],
//     });

//     const sectionHeight = height / 2;
//     const sectionWidth = width;
//     const bannerImgHeight = 94;
//     const maxSectionsPerPage = 2;
//     let currentSection = 0;

//     while (currentSection < sectionsCount.length) {
//         if (currentSection > 0) doc.addPage();

//         const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsCount.length - currentSection);

//         for (let i = 0; i < sectionsOnThisPage; i++) {
//             const sectionIndex = currentSection + i;
//             const yPos = i * sectionHeight;
//             const xPos = 2.5;

//             const section = sectionsCount[sectionIndex];
//             if (!section) continue;

//             const productImageUrl = section.image;
//             const name = section.name;
//             const sku = "Model#" + section.sku;
//             const variation = section.variations?.[0] || {};
//             const sale_price = variation.sale_price;
//             const regular_price = variation.regular_price;
//             const variation_value = variation.value;

//             const bannerImgWidth = width - 5;
//             doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

//             const sectionRectY = yPos + bannerImgHeight + 4.8;
//             const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);
//             const sectionRectX = xPos + 2.5;
//             const sectionRectWidth = width / 2.9;

//             doc.setLineWidth(2);
//             doc.setDrawColor(71, 74, 119);
//             doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, 'S');

//             const sectionMainImageX = xPos + sectionRectWidth + 2.5;
//             const sectionMainImageWidth = width - (sectionRectWidth + 5);
//             const sectionMainImageHeight = 290;
//             if (productImageUrl) {
//                 doc.addImage(productImageUrl, "JPEG", sectionMainImageX, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);
//             }

//             doc.setFont("Montserrat-Bold", "bold");
//             doc.setTextColor(0, 0, 0);
//             doc.setFontSize(14);
//             const textX = sectionMainImageX + (sectionMainImageWidth - 15);
//             const textY = sectionRectY + 15;
//             doc.text(name, textX, textY, { align: 'right' });

//             doc.setFontSize(16);
//             doc.setFont("helvetica", "normal");
//             doc.text(sku, textX, textY + 20, { align: 'right' });

//             const lineY = sectionRectY + sectionRectHeight / 4;
//             doc.line(sectionRectX, lineY, sectionRectX + sectionRectWidth, lineY);

//             const subSection1Width = width / 2.9;
//             const wasPriceStartY = yPos;

//             doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//             doc.setTextColor(40, 142, 169);
//             doc.setFontSize(11);
//             const text1Width = doc.getTextWidth(variation_value);
//             const wasPriceStartX1 = xPos + (subSection1Width - text1Width) / 2;
//             doc.text(variation_value, wasPriceStartX1, wasPriceStartY + 120);

//             const text2 = "was $" + regular_price;
//             doc.setTextColor(0, 0, 0);
//             doc.setFontSize(16);
//             const text2Width = doc.getTextWidth(text2);
//             const wasPriceStartX2 = xPos + (subSection1Width - text2Width) / 2;
//             doc.text(text2, wasPriceStartX2, wasPriceStartY + 140);

//             const text3 = "$" + sale_price;
//             doc.setFont("Montserrat-Black", "normal");
//             doc.setTextColor(253, 0, 0);
//             doc.setFontSize(50);
//             const text3Width = doc.getTextWidth(text3);
//             const wasPriceStartX3 = xPos + (subSection1Width - text3Width) / 2;
//             doc.text(text3, wasPriceStartX3, wasPriceStartY + 190);

//             // === Group Pricing ===
//             if (section.variations.length > 1) {
//                 doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//                 doc.setTextColor(0, 0, 0);
//                 doc.setFontSize(11);
//                 doc.text("Group Pricing", xPos + 10, lineY + 20);

//                 for (let v = 1; v < section.variations.length; v++) {
//                     const varItem = section.variations[v];
//                     const yOffset = lineY + 20 + v * 20;

//                     doc.setFontSize(8);
//                     doc.setTextColor(0, 0, 0);
//                     doc.text(varItem.value || "N/A", xPos + 10, yOffset);

//                     const valueWidth = doc.getTextWidth(varItem.value || "N/A");
//                     doc.setTextColor(253, 0, 0);
//                     doc.text(`$${varItem.sale_price || "0.00"}`, xPos + 10 + valueWidth + 5, yOffset);
//                 }
//             }

//             // === Finance Box ===
//             const gridRectX = xPos + (width / 1.49);
//             const gridRectY = yPos + sectionHeight / 1.39 + 0.5;
//             const gridRectW = width / 3.1;
//             const gridRectH = sectionHeight / 3.75;

//             doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');

//             const lineHeight = 15;
//             const verticalOffset = (gridRectH - (4 * lineHeight)) / 2;

//             const text1_main = "$" + getAdjustedPrice(sale_price).toString();
//             const text1_suffix = "/week";

//             doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//             doc.setFontSize(34);
//             const width_main = doc.getTextWidth(text1_main);
//             doc.setFont("helvetica", "normal");
//             doc.setFontSize(14);
//             const width_suffix = doc.getTextWidth(text1_suffix);
//             const totalWidth = width_main + width_suffix + 2;
//             const textX_g1 = gridRectX + (gridRectW / 2);
//             const textY_g1 = gridRectY + verticalOffset;
//             const combinedTextX = textX_g1 - (totalWidth / 2);

//             doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//             doc.setTextColor(253, 0, 0);
//             doc.setFontSize(34);
//             doc.text(text1_main, combinedTextX, textY_g1);
//             doc.setFont("helvetica", "bold");
//             doc.setTextColor(61, 124, 157);
//             doc.setFontSize(18);
//             doc.text(text1_suffix, combinedTextX + width_main + 2, textY_g1);

//             doc.setFont("helvetica", "normal");
//             doc.setTextColor(151, 68, 131);
//             doc.setFontSize(13);
//             doc.text("Subject to approval. some restrictions apply", textX_g1, textY_g1 + lineHeight + 12, { align: 'center' });

//             doc.setFont("helvetica", "bold");
//             doc.setTextColor(136, 194, 87);
//             doc.setFontSize(24);
//             doc.text("NO CREDIT 0 DOWN", textX_g1, textY_g1 + (3.5 * lineHeight) + 5, { align: 'center' });

//             doc.setFont("helvetica", "bold");
//             doc.setTextColor(56, 112, 151);
//             doc.setFontSize(18);
//             doc.text("100 DAYS NO INTEREST", textX_g1, textY_g1 + (5.5 * lineHeight) + 5, { align: 'center' });

//             // === Individuals Box ===
//             const rightRectX = xPos + (width / 2.83);
//             const rightRectY = yPos + sectionHeight / 1.39 + 0.5;
//             const rightRectW = width / 3.2;
//             const rightRectH = sectionHeight / 3.75;

//             doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, 'S');

//             const col1 = rightRectW * 0.3;
//             const col2 = rightRectW * 0.2;
//             const col3 = rightRectW * 0.3;
//             const col4 = rightRectW * 0.2;
//             const rowHeight = rightRectH / 4;

//             for (let r = 1; r < 5; r++) {
//                 const y = rightRectY + r * rowHeight;
//                 doc.line(rightRectX, y, rightRectX + rightRectW, y);
//             }

//             const colX1 = rightRectX + col1;
//             const colX2 = colX1 + col2;
//             const colX3 = colX2 + col3;
//             doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH);
//             doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH);
//             doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH);

//             const values = section.individuals || [];
//             const itemsPerRow = 2;
//             const totalRows = Math.ceil(values.length / itemsPerRow);

//             for (let r = 0; r < totalRows; r++) {
//                 const y = rightRectY + (r + 1) * rowHeight;
//                 const left = values[r * 2];
//                 const right = values[r * 2 + 1];

//                 if (left) {
//                     const label = left.inputValue || "";
//                     const slug = left.p_price ? "$" + left.p_price : "";
//                     const labelX = rightRectX + col1 / 2 - 30;
//                     const slugX = rightRectX + col1 + col2 / 2 - 15;
//                     const textY = y - rowHeight / 2 + 2;
//                     doc.setFont("Montserrat-BoldItalic", "bolditalic");
//                     doc.setTextColor(0, 0, 0);
//                     doc.setFontSize(12);
//                     doc.text(label, labelX, textY);
//                     doc.setTextColor(252, 0, 0);
//                     doc.text(slug, slugX, textY);
//                 }

//                 if (right) {
//                     const label = right.inputValue || "";
//                     const slug = right.p_price ? "$" + right.p_price : "";
//                     const labelX = rightRectX + col1 + col2 + col3 / 2 - 30;
//                     const slugX = rightRectX + col1 + col2 + col3 + col4 / 2 - 15;
//                     const textY = y - rowHeight / 2 + 2;
//                     doc.setFont("Montserrat-BoldItalic", "bolditalic");
//                     doc.setTextColor(0, 0, 0);
//                     doc.setFontSize(12);
//                     doc.text(label, labelX, textY);
//                     doc.setTextColor(252, 0, 0);
//                     doc.text(slug, slugX, textY);
//                 }
//             }
//         }
//         currentSection += sectionsOnThisPage;
//     }

//     doc.save("price-tags.pdf");
// };



















import { jsPDF } from "jspdf";
import banner1 from "../../../Assets/ptags/banner.jpg";
import { Url, getAdjustedPrice } from "../../../Services/Api";

import "../../../Assets/ptags/fonts/Montserrat-Bold";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
import "../../../Assets/ptags/fonts/Montserrat-Black";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
import "../../../Assets/ptags/fonts/anton";


const now = new Date();
const timestamp = now
  .toISOString()           // e.g., "2025-08-15T21:45:30.123Z"
  .replace(/[:.]/g, '-')   // Replace colon and dot with dash
  .replace('T', '_')       // Replace 'T' with underscore
  .split('Z')[0];          // Remove trailing 'Z'


export const generatePDFOpt2 = (sectionsCount, bannerImg) => {
    const width = 816;
    const height = 1056;
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [width, height],
    });

    const sectionHeight = height / 2;
    const sectionWidth = width;
    const bannerImgHeight = 94;
    const maxSectionsPerPage = 2;
    let currentSection = 0;

    while (currentSection < sectionsCount.length) {
        if (currentSection > 0) doc.addPage();

        const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsCount.length - currentSection);

        for (let i = 0; i < sectionsOnThisPage; i++) {
            const sectionIndex = currentSection + i;
            const yPos = i * sectionHeight;
            const xPos = 2.5;

            const section = sectionsCount[sectionIndex];
            if (!section) continue;

            const productImageUrl = section.image;
            const name = section.name;
            const sku = "Model#" + section.sku;
            const variation = section.variations?.[0] || {};
            const sale_price = variation.sale_price;
            const regular_price = variation.regular_price;
            const variation_value = variation.value;

            const bannerImgWidth = width - 5;
            doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

            const sectionRectY = yPos + bannerImgHeight + 4.8;
            const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);
            const sectionRectX = xPos + 2.5;
            const sectionRectWidth = width / 2.9;

            doc.setLineWidth(2);
            doc.setDrawColor(71, 74, 119);
            doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, 'S');

            const sectionMainImageX = xPos + sectionRectWidth + 2.5;
            const sectionMainImageWidth = width - (sectionRectWidth + 5);
            const sectionMainImageHeight = 290;
            if (productImageUrl) {
                doc.addImage(productImageUrl, "JPEG", sectionMainImageX+5, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);
            }

            doc.setFont("Montserrat-Bold", "bold");
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(14);
            const textX = sectionMainImageX + (sectionMainImageWidth - 15);
            const textY = sectionRectY + 15;
            doc.text(name, textX, textY, { align: 'right' });

            doc.setFontSize(16);
            doc.setFont("helvetica", "normal");
            doc.text(sku, textX, textY + 20, { align: 'right' });

            const lineY = sectionRectY + sectionRectHeight / 4;
            doc.line(sectionRectX, lineY, sectionRectX + sectionRectWidth, lineY); //SEPARATION LINE IN WAS PRIOCE AN DVARIATIONS LIST

            const subSection1Width = width / 2.9;
            const wasPriceStartY = yPos;

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setTextColor(40, 142, 169);
            doc.setFontSize(11);
            const text1Width = doc.getTextWidth(variation_value);
            const wasPriceStartX1 = xPos + (subSection1Width - text1Width) / 2;
            doc.text(variation_value, wasPriceStartX1, wasPriceStartY + 120);

            const text2 = "was $" + regular_price;
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(16);
            const text2Width = doc.getTextWidth(text2);
            const wasPriceStartX2 = xPos + (subSection1Width - text2Width) / 2;
            doc.text(text2, wasPriceStartX2, wasPriceStartY + 140);

            const text3 = "$" + sale_price;
            doc.setFont("Montserrat-Black", "normal");
            doc.setTextColor(253, 0, 0);
            doc.setFontSize(50);
            const text3Width = doc.getTextWidth(text3);
            const wasPriceStartX3 = xPos + (subSection1Width - text3Width) / 2;
            doc.text(text3, wasPriceStartX3, wasPriceStartY + 190);

            if (section.variations.length > 1) {
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(11);
                doc.text("Group Pricing", xPos + 10, lineY + 20);

                for (let v = 1; v < section.variations.length; v++) {
                    const varItem = section.variations[v];
                    const yOffset = lineY + 20 + v * 20;

                    doc.setFontSize(8);
                    doc.setTextColor(0, 0, 0);
                    doc.text(varItem.value || "N/A", xPos + 10, yOffset);

                    const valueWidth = doc.getTextWidth(varItem.value || "N/A");
                    doc.setTextColor(253, 0, 0);
                    doc.text(`$${varItem.sale_price || "0.00"}`, xPos + 10 + valueWidth + 5, yOffset);
                }
            }

            const gridRectX = xPos + (width / 1.49);
            const gridRectY = yPos + sectionHeight / 1.39 + 0.5;
            const gridRectW = width / 3.1;
            const gridRectH = sectionHeight / 3.75;

            // doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');
            doc.setLineWidth(2); // Ensure border is thick enough
            doc.setDrawColor(71, 74, 119); // Same as left border color
            doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');


            const lineHeight = 15;
            const verticalOffset = (gridRectH - (4 * lineHeight)) / 2;

            const text1_main = "$" + getAdjustedPrice(sale_price).toString();
            const text1_suffix = "/week";

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setFontSize(34);
            const width_main = doc.getTextWidth(text1_main);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(14);
            const width_suffix = doc.getTextWidth(text1_suffix);
            const totalWidth = width_main + width_suffix + 2;
            const textX_g1 = gridRectX + (gridRectW / 2);
            const textY_g1 = gridRectY + verticalOffset;
            const combinedTextX = textX_g1 - (totalWidth / 2);

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setTextColor(253, 0, 0);
            doc.setFontSize(34);
            doc.text(text1_main, combinedTextX, textY_g1);
            doc.setFont("helvetica", "bold");
            doc.setTextColor(61, 124, 157);
            doc.setFontSize(18);
            doc.text(text1_suffix, combinedTextX + width_main + 2, textY_g1);

            doc.setFont("helvetica", "normal");
            doc.setTextColor(151, 68, 131);
            doc.setFontSize(13);
            doc.text("Subject to approval. some restrictions apply", textX_g1, textY_g1 + lineHeight + 12, { align: 'center' });

            doc.setFont("helvetica", "bold");
            doc.setTextColor(136, 194, 87);
            doc.setFontSize(24);
            doc.text("NO CREDIT 0 DOWN", textX_g1, textY_g1 + (3.5 * lineHeight) + 5, { align: 'center' });

            doc.setFont("helvetica", "bold");
            doc.setTextColor(56, 112, 151);
            doc.setFontSize(18);
            doc.text("100 DAYS NO INTEREST", textX_g1, textY_g1 + (5.5 * lineHeight) + 5, { align: 'center' });

            const rightRectX = xPos + (width / 2.83);
            const rightRectY = yPos + sectionHeight / 1.39 + 0.5;
            const rightRectW = width / 3.2;
            const rightRectH = sectionHeight / 3.75;

            doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, 'S');

            const col1 = rightRectW * 0.3;
            const col2 = rightRectW * 0.2;
            const col3 = rightRectW * 0.3;
            const col4 = rightRectW * 0.2;
            const rowHeight = rightRectH / 4;

            for (let r = 1; r < 5; r++) {
                const y = rightRectY + r * rowHeight;
                doc.line(rightRectX, y, rightRectX + rightRectW, y);
            }

            const colX1 = rightRectX + col1;
            const colX2 = colX1 + col2;
            const colX3 = colX2 + col3;
            doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH);
            doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH);
            doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH);

            const values = section.individuals || [];
            const itemsPerRow = 2;
            const totalRows = Math.ceil(values.length / itemsPerRow);

            for (let r = 0; r < totalRows; r++) {
                const y = rightRectY + (r + 1) * rowHeight;
                const left = values[r * 2];
                const right = values[r * 2 + 1];

                if (left) {
                    const label = left.inputValue || "";
                    const slug = left.p_price ? "$" + left.p_price : "N/A";
                    const labelX = rightRectX + col1 / 2 - 30;
                    const slugX = rightRectX + col1 + col2 / 2 - 15;
                    const textY = y - rowHeight / 2 + 2;
                    doc.setFont("Montserrat-BoldItalic", "bolditalic");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12);
                    doc.text(label, labelX, textY);
                    doc.setTextColor(252, 0, 0);
                    doc.text(slug, slugX, textY);
                }

                if (right) {
                    const label = right.inputValue || "";
                    const slug = right.p_price ? "$" + right.p_price : "N/A";
                    const labelX = rightRectX + col1 + col2 + col3 / 2 - 30;
                    const slugX = rightRectX + col1 + col2 + col3 + col4 / 2 - 15;
                    const textY = y - rowHeight / 2 + 2;
                    doc.setFont("Montserrat-BoldItalic", "bolditalic");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12);
                    doc.text(label, labelX, textY);
                    doc.setTextColor(252, 0, 0);
                    doc.text(slug, slugX, textY);
                }
            }
        }

        // Add horizontal dashed divider between sections on the same page
        if (sectionsOnThisPage === 2) {
            const dashY = sectionHeight - 2;
            doc.setLineDashPattern([10, 5], 0);
            doc.setDrawColor(0);
            doc.setLineWidth(1);
            doc.line(0, dashY, width, dashY);
            doc.setLineDashPattern([], 0); // Reset dash pattern
        }

        currentSection += sectionsOnThisPage;
    }

    doc.save(`price-tags_${timestamp}.pdf`);
};
